import "core-js/modules/es.string.includes";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import PropTypes from 'prop-types';

function TextDecorator(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      decoration = _ref.decoration,
      rest = _objectWithoutProperties(_ref, ["children", "classes", "decoration"]);

  return React.createElement("span", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, "completed strike lineThrough".includes(decoration) && classes.lineThrough, {
      'underline': classes.underline,
      'overline': classes.overline
    }[decoration])
  }), children);
}

TextDecorator.propTypes = {
  /**
   * Content
   */
  children: PropTypes.node,
  classes: PropTypes.shape({
    lineThrough: PropTypes.string,
    overline: PropTypes.string,
    root: PropTypes.string,
    underline: PropTypes.string
  }).isRequired,
  className: PropTypes.string,

  /**
   * Type of applied decoration.
   */
  decoration: PropTypes.oneOf(['none', 'completed', 'strike', 'lineThrough', 'underline', 'overline'])
};
TextDecorator.defaultProps = {
  children: null,
  className: undefined,
  decoration: 'none'
};

var styles = function styles() {
  return (
    /* theme */
    {
      root: {
        display: 'inline-block'
      },
      lineThrough: {
        textDecoration: 'line-through'
      },
      overline: {
        textDecoration: 'overline'
      },
      underline: {
        textDecoration: 'underline'
      }
    }
  );
};

export default withStyles(styles, {
  name: 'SxTextDecorator'
})(TextDecorator);